"use client"

import { useEffect, useState } from "react"
import { useToast } from "./use-toast"
import { Toast as BootstrapToast } from "react-bootstrap"

type ToasterProps = {}

export function Toaster({}: ToasterProps) {
  const { toasts } = useToast()
  const [visibleToasts, setVisibleToasts] = useState<Array<{ id: string; toast: any }>>([])

  useEffect(() => {
    // When toasts change, update the visible toasts
    if (toasts.length > 0) {
      // Generate a unique ID for each toast
      const newToasts = toasts.map((toast) => ({
        id: Math.random().toString(36).substring(2, 9),
        toast,
      }))

      setVisibleToasts((prev) => [...prev, ...newToasts])

      // Set up timeouts to remove toasts after they're shown
      newToasts.forEach((toast) => {
        setTimeout(() => {
          setVisibleToasts((prev) => prev.filter((t) => t.id !== toast.id))
        }, 3000) // 3 seconds
      })
    }
  }, [toasts])

  if (visibleToasts.length === 0) {
    return null
  }

  return (
    <div className="position-fixed bottom-0 end-0 p-3" style={{ zIndex: 1050 }}>
      {visibleToasts.map(({ id, toast }) => (
        <BootstrapToast
          key={id}
          bg={toast.variant === "destructive" ? "danger" : "success"}
          className="mb-2"
          onClose={() => setVisibleToasts((prev) => prev.filter((t) => t.id !== id))}
        >
          <BootstrapToast.Header>
            <strong className="me-auto">{toast.title}</strong>
          </BootstrapToast.Header>
          <BootstrapToast.Body className={toast.variant === "destructive" ? "text-white" : undefined}>
            {toast.description}
          </BootstrapToast.Body>
        </BootstrapToast>
      ))}
    </div>
  )
}

